import { format } from 'date-fns'
import { useMemo } from 'react'
import { Contract_workdays as Workday } from '../../../typings/Contract'

interface Props {
  endsAt: Workday['endsAt']
}

export const EndTime = ({ endsAt }: Props) => {
  const endTime = useMemo(() => {
    return format(new Date(endsAt), 'HH:mm')
  }, [endsAt])

  return <>{endTime}</>
}
